export const ourMissionList = [
  "Покращення фізичного здоров’я дітей та дорослих;",
  "Відновлення фізичних якостей та вмінь після захворювань та травм;",
  "Максимально можлива адаптація та навчання самообслуговування у повсякденному житті;",
  "Попередження розвитку ускладнень та повернення людини до повноцінного життя.",
];
